var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "720" },
      model: {
        value: _vm.dialogOpen,
        callback: function($$v) {
          _vm.dialogOpen = $$v
        },
        expression: "dialogOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              ref: "exchangeConfigurationForm",
              attrs: {
                "lazy-validation": "",
                autocomplete: "off",
                onSubmit: "return false;"
              },
              on: { submit: _vm.saveExchangeDialog },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-card-title", { staticClass: "text-h6" }, [
                _vm._v(_vm._s(_vm.$t("providers.MicrosoftExchange")))
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.required, _vm.url],
                              label: _vm.$t("providers.exchangeServerUrl"),
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.exchangeServerUrl,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "exchangeServerUrl",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.exchangeServerUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.required],
                              label: _vm.$t("providers.accountName"),
                              autocomplete: "new-password",
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.accountName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "accountName",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.accountName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.required],
                              label: _vm.$t("providers.accountPassword"),
                              type: "password",
                              autocomplete: "new-password",
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.accountPassword,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "accountPassword",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.accountPassword"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2",
                      attrs: { text: "", small: "" },
                      on: {
                        click: function($event) {
                          _vm.showAdvanced = !_vm.showAdvanced
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.showAdvanced
                              ? _vm.$t("providers.hideAdvancedSettings")
                              : _vm.$t("providers.showAdvancedSettings")
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showAdvanced,
                          expression: "showAdvanced"
                        }
                      ]
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("providers.accountRoomName"),
                              rules: [_vm.validMail],
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.accountRoomName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "accountRoomName",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.accountRoomName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("providers.accountDomainName"),
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.accountDomainName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "accountDomainName",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.accountDomainName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.exchangeVersionOptions,
                              "item-text": "label",
                              "item-value": "value",
                              label: _vm.$t("policiesFields.ExchangeVersion"),
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.exchangeDialogForm.exchangeVersion,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.exchangeDialogForm,
                                  "exchangeVersion",
                                  $$v
                                )
                              },
                              expression: "exchangeDialogForm.exchangeVersion"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { text: "" }, on: { click: _vm.onCancel } },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.saveExchangeDialog }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }